import { GroupedTraits } from '../../models/traits';
import { audiencerateApi } from '../audiencerate';
import { getTraitDisplayName } from '../../utils/traitTranslations';

const traitsApi = audiencerateApi.injectEndpoints({
  endpoints: (build) => ({
    getTraits: build.query<GroupedTraits, GetTraitsArg>({
      query: ({ limit, offset, workspaceId }) => ({
        url: `/v1/workspaces/${workspaceId}/traits`,
        params: { limit, offset },
      }),
      transformResponse: (response: GroupedTraits) => {
        // Transform customer traits
        const customerTraits = response.customer?.map(trait => ({
          ...trait,
          displayName: getTraitDisplayName(trait.id)
        })) || [];

        // Transform event traits  
        const eventTraits = response.event?.map(trait => ({
          ...trait,
          displayName: getTraitDisplayName(trait.id)
        })) || [];

        return {
          customer: customerTraits,
          event: eventTraits
        };
      },
      providesTags: ['Traits'],
    }),
  }),
  overrideExisting: false,
});

type GetTraitsArg = {
  limit?: number;
  offset?: number;
  workspaceId: string;
};

export const { useGetTraitsQuery, useLazyGetTraitsQuery } = traitsApi;
